import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "home--sprite",
  "use": "home--sprite-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"home--sprite\">\n<path d=\"M10.0003 5.15829L14.167 8.90829V15.4166H12.5003V10.4166H7.50033V15.4166H5.83366V8.90829L10.0003 5.15829ZM10.0003 2.91663L1.66699 10.4166H4.16699V17.0833H9.16699V12.0833H10.8337V17.0833H15.8337V10.4166H18.3337L10.0003 2.91663Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol